import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import EditSeoPage from './EditSeoPage';

async function action({ store, params }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) return { redirect: '/login' };
  const id = Number(params.id);

  return {
    title: 'Edit SEO Page',
    component: <AdminLayout><EditSeoPage id={id} /></AdminLayout>,
  };
}

export default action;
